import { useLocation, useNavigate, useParams } from 'react-router'

import { useEntityProfileTabsActiveTab } from '../../../../../Entity'

import { getListingProfileTabUrl } from './useListingProfileTabsActiveTab.utils'

export function useListingProfileTabsActiveTab({ listingData, preparedTabs }) {
  const navigate = useNavigate()

  const location = useLocation()

  const { listingId } = useParams()

  function getTabUrl(tab) {
    return getListingProfileTabUrl({ listingId, tab })
  }

  const { activeTabId } = useEntityProfileTabsActiveTab({
    getTabUrl,
    isEntityLoaded: Boolean(listingData),
    preparedTabs,
  })

  function handleSetActiveTab(tabId) {
    navigate(
      {
        hash: location.hash,
        pathname: getTabUrl(tabId),
        search: location.search,
      },
      { replace: true }
    )
  }

  return {
    activeTabId,
    handleSetActiveTab,
  }
}
